import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {ARService} from '../../ar.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {DataARCreditDebitReasonModel} from '../../../../models/accountsReceivable/data-ar-credit-debit-reason.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {CreateLedgerItemForPaymentModel} from '../../models/create-ledger-item-for-payment.model';
import {MatTable} from '@angular/material/table';

@Component({
  selector: 'app-ar-debit-credit-reasons',
  templateUrl: './ar-debit-credit-reasons.component.html',
  styleUrls: ['./ar-debit-credit-reasons.component.scss']
})
export class ArDebitCreditReasonsComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  @ViewChild(MatTable) table!: MatTable<any>;

  isLoading: boolean = false;
  enumAdjustmentReasons: EnumValidValueItemModel[] = [];
  creditDebitReasons: DataARCreditDebitReasonModel[] = [];
  creditDebitReasonsTable: DataARCreditDebitReasonModel[] = [];
  creditDebitReasonsRemoved: DataARCreditDebitReasonModel[] = [];
  LOCID: number;
  showCreditReasons: boolean = false;
  showDebitReasons: boolean = false;
  enumCreditDebitTypeCredit: string = '00000538-1000-0000-0000-000000000001';
  enumCreditDebitTypeDebit: string = '00000538-1000-0000-0000-000000000002';

  columnsToDisplayTopRow = ['Reason', 'enumCreditDebitTypeID', 'CreditDebitReasonID'];

  constructor(
    public dialogRef: MatDialogRef<ArDebitCreditReasonsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    public globals: Globals,
    private dialog: MatDialog,

  ) {  }

  ngOnInit() {
    this.LOCID = parseInt(localStorage.getItem('LOCID'));

    if (this.data.reasonType === 'credit') {
      this.showCreditReasons = true;
    }
    else if (this.data.reasonType === 'debit') {
      this.showDebitReasons = true;
    }

    this.init();
  }

  init() {

    this.isLoading = true;

    const promises: any[] = [
      this.arService.getDebitCreditReasons(this.LOCID).toPromise()
    ];
    if (this.showDebitReasons) {
      promises.push(this.arService.getEnumValidValueItemsByValidValueName('enumARReasonDebitAdjustment').toPromise());
    }
    else if (this.showCreditReasons) {
      promises.push(this.arService.getEnumValidValueItemsByValidValueName('enumARReasonCreditAdjustment').toPromise());
    }

    Promise.all(promises).then((results: any[]) => {
      this.creditDebitReasons =  results[0];
      this.enumAdjustmentReasons = results[1];
      this.isLoading = false;

      // filter by type
      if (this.showCreditReasons) {
        this.creditDebitReasonsTable = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeCredit);
      } else {
        this.creditDebitReasonsTable = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeDebit);
      }
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  canSave() {

    let canSave = true;
    this.creditDebitReasonsTable.forEach(a => {
      if (a.Reason.length && (a.enumARReasonCreditAdjustmentID || a.enumARReasonDebitAdjustmentID)) {
        // all good
      }
      else {
        canSave = false;
      }
    });

    return canSave;
  }

  saveChanges() {
    // send post
    this.SaveCreditDebitReasons().then((success: DataARCreditDebitReasonModel[]) => {
      if (success) {
        this.createMessage('Reasons Saved', 'Success');
        this.creditDebitReasonsTable = success;
        if (this.showCreditReasons) {
          this.creditDebitReasonsTable = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeCredit);
        } else {
          this.creditDebitReasonsTable = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeDebit);
        }

        // close window for now
        this.dialogRef.close(true);
      }
      else {
        this.createMessage('Reasons Not Saved', 'Error');
      }
    });
  }

  addRow() {
    const row = new DataARCreditDebitReasonModel();
    row.LOCID = this.LOCID;
    row.Reason = '';
    row.enumARReasonCreditAdjustmentID = null;
    row.enumARReasonDebitAdjustmentID = null;
    row.enumCreditDebitTypeID = this.showDebitReasons ? this.enumCreditDebitTypeDebit : this.enumCreditDebitTypeCredit;
    this.creditDebitReasonsTable.push(row);

    // update table
    // this.tdoTable.updateData();
    this.table.renderRows();
  }

  removeReason(CreditDebitReasonID: string) {
    // set xauditdeleted to true
    this.creditDebitReasonsTable.forEach(t => {
      if (t.CreditDebitReasonID === CreditDebitReasonID) {
        t.xauditDeleted = true;
        this.creditDebitReasonsRemoved.push(t);
      }
    });

    // reload data and table
    this.creditDebitReasonsTable = this.creditDebitReasonsTable.filter(a => a.CreditDebitReasonID !== CreditDebitReasonID);
    this.table.renderRows();
  }

  // DeleteCreditDebitReason(CreditDebitReasonID: string) {
  //   const promise = new Promise((resolve, reject) => {
  //     this.arService.DeleteCreditDebitReason(CreditDebitReasonID)
  //       .subscribe(resolve, reject);
  //   });
  //   return promise;
  // }

  SaveCreditDebitReasons() {

    // first append any deleted records to be sent to server
    this.creditDebitReasonsRemoved.forEach(a => {
      this.creditDebitReasonsTable.push(a);
    });

    const promise = new Promise((resolve, reject) => {
      this.arService.SaveCreditDebitReasons(this.creditDebitReasonsTable)
        .subscribe(resolve, reject);
    });
    return promise;
  }
}
